import { Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Carlos M.",
    text: "Precisei de guincho de madrugada e fui atendido super rapido. Profissional muito atencioso!",
    avatar: "https://images.unsplash.com/photo-1654762699761-b6d13143bb2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxjdXN0b21lciUyMHBvcnRyYWl0JTIwcHJvZmlsZXxlbnwwfHx8fDE3NzYzMzM3NDV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Juliana R.",
    text: "Excelente servico! Chegaram rapido e cuidaram muito bem do meu carro.",
    avatar: "https://images.unsplash.com/photo-1634162635368-004f5fb27427?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxjdXN0b21lciUyMHBvcnRyYWl0JTIwcHJvZmlsZXxlbnwwfHx8fDE3NzYzMzM3NDV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Roberto S.",
    text: "Preco justo e atendimento agil. Recomendo demais!",
    avatar: "https://images.unsplash.com/photo-1638959882925-def54998de76?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxjdXN0b21lciUyMHBvcnRyYWl0JTIwcHJvZmlsZXxlbnwwfHx8fDE3NzYzMzM3NDV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Marcos L.",
    text: "Meu carro quebrou na estrada e eles resolveram tudo rapidamente. Servico top!",
    avatar: null,
  },
  {
    name: "Fernanda P.",
    text: "Atendimento 24h de verdade! Me salvou numa emergencia.",
    avatar: null,
  },
];

function StarRating() {
  return (
    <div className="flex gap-0.5 mb-3">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          className="w-4 h-4 fill-[#FFD700] text-[#FFD700]"
        />
      ))}
    </div>
  );
}

function AvatarPlaceholder({ name }) {
  const initial = name.charAt(0);
  return (
    <div className="w-10 h-10 rounded-full bg-[#FFD700] flex items-center justify-center flex-shrink-0">
      <span className="text-black font-bold text-sm" style={{ fontFamily: "'Oswald', sans-serif" }}>
        {initial}
      </span>
    </div>
  );
}

export default function Reviews() {
  return (
    <section
      id="avaliacoes"
      data-testid="reviews-section"
      className="py-24 sm:py-32 bg-black"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-[#FFD700] text-black px-3 py-1 text-xs font-bold uppercase tracking-widest mb-6">
            Avaliacoes
          </div>
          <h2
            data-testid="reviews-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight uppercase mb-4"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            O que nossos <span className="text-[#FFD700]">clientes</span> dizem
          </h2>
          <p className="text-gray-400 text-base max-w-lg mx-auto">
            Atendimento rapido, seguro e de confianca. Veja a experiencia de
            quem ja utilizou nossos servicos.
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((review, i) => (
            <div
              key={i}
              data-testid={`review-card-${i}`}
              className="review-card bg-[#0A0A0A] border border-[#27272A] p-6 rounded-sm"
            >
              <StarRating />
              <p className="text-gray-300 text-sm leading-relaxed mb-4 italic">
                "{review.text}"
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-[#27272A]">
                {review.avatar ? (
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  />
                ) : (
                  <AvatarPlaceholder name={review.name} />
                )}
                <span className="text-sm font-bold text-white">
                  {review.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
